import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    CircularProgress,
    Typography,
    IconButton,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';

const ConfirmDialog = ({
    open,
    title,
    children,
    confirmText = 'Confirm',
    confirmDisabled = false,
    cancelText = 'Cancel',
    onConfirm,
    onCancel,
    onClose = onCancel,
    showCloseIcon = false,
    isLoading = false,
    confirmColor = 'primary',
    maxWidth = 'sm',
    fullWidth = true,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
        >
            <DialogTitle disableTypography style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h4' style={{ fontWeight: 600 }}>
                    {title}
                </Typography>
                {showCloseIcon &&
                    <IconButton aria-label='close' onClick={onClose} size='small'>
                        <Close />
                    </IconButton>
                }
            </DialogTitle>

            <DialogContent dividers>
                {children}
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel} disabled={isLoading}>
                    {cancelText}
                </Button>

                <Button
                    onClick={onConfirm}
                    color={confirmColor}
                    variant='contained'
                    disabled={isLoading || confirmDisabled}
                >
                    {isLoading ? (
                        <CircularProgress size={20} />
                    ) : (
                        confirmText
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;